module.exports = __webpack_public_path__ + "img/link-simple-slash.8ac28587.svg";